import { ID } from '@datorama/akita';

import { appearance } from '../mapper.appearance';
import { MapperComponent } from '../mapper.component';
import { MappingField, MappingFieldOptions } from '../mapping-field/mapping-field';

declare let fabric: any;

export interface MappingCheckBoxOptions {
  clientX: number;
  clientY: number;
  counterSign: boolean;
  height: number;
  id?: ID;
  scaleX: number;
  width: number;
}

export class MappingCheckBox extends fabric.Group {
  checked: boolean;
  counterSign: boolean;
  innerBox: any;
  mapperComponent: MapperComponent;
  outerBox: MappingField;

  get backgroundColor(): string {
    return this.counterSign ? appearance.counterBackgroundColor : appearance.deselectedColor;
  }

  set backgroundColor(color: string) {
    // No-op function required to prevent errors in fabric
  }

  get borderColor(): string {
    return this.counterSign ? appearance.countersignBorderColor : appearance.primaryBorderColor;
  }

  set borderColor(color: string) {
    // No-op function required to prevent errors in fabric
  }

  constructor(options: MappingCheckBoxOptions, id: ID, mapperComponent: MapperComponent) {
    super();

    this.mapperComponent = mapperComponent;
    let mappingFieldOptions: MappingFieldOptions = {
      borderScaleFactor: 2,
      counterSign: options.counterSign,
      height: options.height,
      left: options.clientX,
      noScaleCache: false,
      opacity: 1,
      scaleX: options.scaleX,
      top: options.clientY,
    };
    this.outerBox = new MappingField('', mappingFieldOptions, id, mapperComponent);
    this.counterSign = options.counterSign;
    this.innerBox = new fabric.Rect({
      fill: appearance.transparent,
      height: 13,
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      left: options.clientX + 6,
      stroke: appearance.black,
      strokeWidth: 1.5,
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      top: options.clientY + 6,
      width: 13
    });

    this.initialize([this.outerBox, this.innerBox], {
      borderScaleFactor: 2,
      noScaleCache: false
    });
    this.setColors();

    this.setControlsVisibility({
      bl: false,
      br: false,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false,
      tl: false,
      tr: false
    });
    this._bindEvents();
  }

  _bindEvents(): void {
    this.on('selected', () => {
      this.setColors(0.8);
    });

    this.on('deselected', () => {
      this.setColors();
    });
  }

  setColors(opacity: number = 1): void {
    this.outerBox.set({
      backgroundColor: this.backgroundColor,
      opacity
    });

    this.set({
      borderColor: this.borderColor,
      cornerColor: this.borderColor
    });
  }
}
